<activities-block
  entityType="sale"
  [entityId]="(sale$ | async)?.id"
  [extraFilters]="extraFilters"
  [joins]="[{ field: 'member' }, { field: 'user' }, { field: 'product' }]"
  [initialLimit]="25"
  showParent="false"
  wcagLabel="wcag.logsMenu"
></activities-block>
